import React from 'react';
import { SITE_CONTENT } from '../constants';

const Technique: React.FC = () => {
  const { tecnica } = SITE_CONTENT;
  const [src, setSrc] = React.useState(tecnica.image);
  const fallback = "https://images.unsplash.com/photo-1526218626217-dc65a29bb444?q=80&w=2070&auto=format&fit=crop";

  return (
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-start">
        <div className="order-2 lg:order-1">
          <div className="relative inline-block mb-4">
            <h2 className="text-4xl md:text-5xl font-serif text-white relative z-10">
              {tecnica.title}
            </h2>
            <div className="absolute -bottom-2 -left-2 w-20 h-20 bg-gold/10 -z-0" />
          </div>
          <p className="text-lg text-white/90 leading-relaxed mb-12 italic border-l-2 border-gold/30 pl-6">
            {tecnica.description}
          </p>
          
          <div className="space-y-12">
            {tecnica.points.map((point, idx) => (
              <div key={idx} className="flex group animate-fadeIn" style={{ animationDelay: `${idx * 0.1}s` }}>
                <div className="mr-6 shrink-0">
                  <span className="text-2xl font-serif text-gold/40 group-hover:text-gold transition-colors duration-500 border-b border-gold/20 pb-1">
                    0{idx + 1}
                  </span>
                </div>
                <div>
                  <h3 className="text-xl text-gold mb-3 uppercase tracking-[0.2em]">
                    {point.title}
                  </h3>
                  <p className="text-white/80 leading-relaxed text-base md:text-lg">
                    {point.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="order-1 lg:order-2 lg:sticky lg:top-40">
          <div className="relative">
            <div className="absolute -inset-4 border border-gold/20" />
            <div className="relative z-10 w-full aspect-[4/5] lg:h-[700px] bg-slate-800 overflow-hidden shadow-2xl">
              <img 
                src={src} 
                alt="Vocal technique" 
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000 transform hover:scale-105"
                onError={() => src !== fallback && setSrc(fallback)}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-midnight/80 via-transparent to-transparent pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Technique;